import React, { Fragment } from 'react';
import Box from 'components/atoms/Box/Box';
import Typography from 'components/atoms/Typography/Typography';
import Image from 'components/atoms/Image/Image';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import Container from 'components/atoms/Container/Container';
export default function SectionTips(props) {
  return (
    <Fragment>
      <Container disableGutters maxWidth="sm">
        <Box textAlign="center" pb={3}>
          <Typography variant="h1">{props.headingText}</Typography>
        </Box>
        <Box textAlign="center">
          <Image src={props.image} />
        </Box>
        <Box pt={3} pb={10}>
          <Paragraph>{props.paragraphText}</Paragraph>
        </Box>
      </Container>
    </Fragment>
  );
}
